import _extends from "@babel/runtime/helpers/esm/extends";
import buildAuditLogsActions from './auditLogsActions.mocks';
import buildAuditsMetadataActions from './auditsMetadataActions.mocks';
export const buildAuditsActions = (store, api, actions) => {
  const auditLogsActions = buildAuditLogsActions(store, api, actions);
  const auditsMetadataActions = buildAuditsMetadataActions(store, api, actions);
  return _extends({}, auditLogsActions, auditsMetadataActions);
};